import { Outlet, Link } from "react-router-dom";
import { DataContainer } from './components/DataContainer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserAsync } from './store/userSlice';
import FNS from './api';

import './Layout.css';
import { UserBadge } from "./elements/UserBadge";
import abuss from './res/abuss.png';

const AdminLayout = () => {
  const dispatch = useDispatch();

  return (
    <div className="column" style={{ width: '100%', minHeight: '100vh', height: 'auto', paddingBottom: '128px' }}>
      <div className="header line center-cross g32" style={{ width: '100%', paddingBlock: '16px', paddingInline: '48px' }}>
        <Link to="/platform" className="default">
          <img src={abuss} style={{ height: "48px" }} />
        </Link>

        <div style={{ flex: 1 }}></div>

        <UserBadge/>
      </div>

        <input style={{display: "none"}} type="checkbox" name="nav-toggle" id="nav-toggle" />

        <label className="nav-icon no-select" for="nav-toggle">
          <b>MENÜÜ</b>
        </label>

        <nav>
          <div className="padder" style={{ width: '32px' }}></div>
          <Link className="nav-button" to="/platform">Töölaud</Link>
          <Link className="nav-button" to="/platform/feedback">Tagasiside</Link>
          <Link className="nav-button" to="/platform/schedule">Graafikud</Link>
          <Link className="nav-button" to="/platform/archive">Arhiiv</Link>
          <Link className="nav-button" to="/platform/resources">Juhid / bussid</Link>
          <Link className="nav-button" to="/platform/driverReports">Juhi aruanded</Link>
          <div className="padder" style={{ marginRight: '32px', flex: 1 }}></div>
        </nav>

      <Outlet />
    </div>
  )
};

export default AdminLayout;